import request from '@/utils/request';
import {
  TMPURL
} from './config';

// 获取留言墙列表
export function getMsgBoardList(params) {
  return request.get(TMPURL + '/v1/public/message/list', params);
}

// 发送留言墙列表
export function sendBoardMsg(params) {
  return request.post(TMPURL + '/v1/public/message/create', params);
}
